/**
 * Stagger-reveal for the Featured Collections product grid as it scrolls
 * into view. Scoped to the initially-active panel only — inactive tab
 * panels are display:none at load, and ScrollTrigger can't reliably
 * compute trigger positions for hidden elements; their cards get a plain
 * instant fade instead when a user switches to them (see
 * furlouve-collections-tabs.js), which doesn't need scroll-triggering
 * since the user just directly asked to see that content.
 */
import { revealOnScroll } from '@theme/premium-motion';

revealOnScroll('.flv-collections__panel--active .flv-product-card', {
  y: 28,
  scale: 0.97,
  duration: 0.7,
  stagger: 0.08,
});
